import React from 'react';
import { Input } from 'rsuite';

import './styles.css';
import { Label } from '../Label';
import { Container, InputWrapper, Sufix } from './style';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').InputProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomInputCurrency component.
 */

export function CustomInputCurrency({ label, percent= false, ...rest }) {
  return (
    <Container>
      {Boolean(label) && <Label htmlFor={rest?.id}>{label}</Label>}
      <InputWrapper>
        <Sufix>{percent ? '%' : 'R$'}</Sufix>
        <Input {...rest} type="number" className="custom-input" min={0} />
      </InputWrapper>
    </Container>
  );
}
